module.exports = __webpack_public_path__ + "static/media/soundAlpha2.2b29db00.mp3";